import { render, staticRenderFns } from "./DisciplineForm.vue?vue&type=template&id=1892e3fe"
import script from "./DisciplineForm.vue?vue&type=script&lang=js"
export * from "./DisciplineForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports